import { NO_SQUARE, type Square } from './types.js';

export const BOARD_SIZE = 8;
export const SQUARE_COUNT = 64;

const FILES = 'abcdefgh';

/** 0 = a-file … 7 = h-file. */
export function fileOf(sq: Square): number {
  return sq & 7;
}

/** 0 = rank 8 … 7 = rank 1 (FEN row order). */
export function rowOf(sq: Square): number {
  return sq >> 3;
}

/** Square at a file and row, or NO_SQUARE when off the board. */
export function squareAt(file: number, row: number): Square {
  if (file < 0 || file >= BOARD_SIZE || row < 0 || row >= BOARD_SIZE) return NO_SQUARE;
  return row * BOARD_SIZE + file;
}

/** "e4" for a square index. */
export function squareName(sq: Square): string {
  return `${FILES.charAt(fileOf(sq))}${BOARD_SIZE - rowOf(sq)}`;
}

/** Square index for "e4", or NO_SQUARE when malformed. */
export function parseSquare(name: string): Square {
  if (name.length !== 2) return NO_SQUARE;
  const file = FILES.indexOf(name.charAt(0));
  const rank = Number(name.charAt(1));
  if (file < 0 || !Number.isInteger(rank) || rank < 1 || rank > BOARD_SIZE) return NO_SQUARE;
  return squareAt(file, BOARD_SIZE - rank);
}
